<template>
  <b-card class="mt-2 text-center">
    <p v-html="stats.cta" />
    <b-progress>
      <b-progress-bar variant="warning" :value="stats.seats_taken" :max="stats.event_capacity"></b-progress-bar>
      <b-progress-bar variant="light" :value="stats.min_to_fire_next_group" :max="stats.event_capacity"></b-progress-bar>
    </b-progress>

    <!-- <b-progress :value="stats.seats_taken" :max="stats.event_capacity" variant="warning" animated></b-progress> -->
    <div v-if="stats.seats_taken > 2">
      <h5 class="pt-4">{{stats.seats_taken}} of {{stats.event_capacity}} seats have been filled.</h5>
      <hr>
    </div>

    <p class="mt-2 mb-0"><small class="text-danger font-weight-bold">Registrations close {{format.datetime(stats.reservations_close_at)}}</small></p>
  </b-card>
</template>

<script>
  export default {
    name: "EventProgressBar",
    props: ["stats"],
    data() {
      return {
        values: [20, 20, 10],
        max: 60
      }
    }
  }
</script>